import NativeLoginPage from '@/pages/native/login/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/native/login')({
  component: NativeLoginPage,
})

